module.exports = __webpack_public_path__ + "static/satellite-fdd8195506fa43ab83f410589cec22f9.jpeg";